<template>
  <b-breadcrumb-item class="al-breadcrumb-item" test-id="al-breadcrumb-item">
    <slot />
  </b-breadcrumb-item>
</template>

<script>
import { BBreadcrumbItem } from 'bootstrap-vue';

export default {
  components: {
    BBreadcrumbItem
  }
};
</script>
